import { useMutation } from '@tanstack/react-query';
import { produce } from 'immer';

import { GET_PRODUCT_QUERY_KEY } from './useGetProduct';

import { queryClient } from '@/lib/queryClient';
import ProductsService, {
  Product,
  UpdatePairsWithDto,
} from '@/services/ProductsService';

export function useUpdatePairsWith(productId: number) {
  const { mutateAsync, isPending } = useMutation({
    mutationFn: (updatePairsWithDto: UpdatePairsWithDto) =>
      ProductsService.updatePairsWith(updatePairsWithDto),
    onSuccess: (data) => {
      queryClient.setQueryData<Product>(
        GET_PRODUCT_QUERY_KEY(productId),
        produce((draft) => {
          draft!.shopTheLook = data.shopTheLook;
        }),
      );
    },
  });

  return {
    updatePairsWith: mutateAsync,
    isLoading: isPending,
  };
}
